import { getInsFromPatient, remoteFormats } from "./index";

export const extractOpenDocumentParams = (data) => {
  const { ins } = getInsFromPatient(data, remoteFormats.XML);
  
  const {
          uniqueId       : { value: uniqueId },
          openLastVersion: { value: openLastVersion },
          addAccessAuthorization: { value: addAccessAuthorization } = {},
          useBdgAccess: {
            value: useBdgAccess
          } = {},
          bdgAccessReason: {
            value: bdgAccessReason
          } = {}
        } = data;
  
  return {
    ins,
    uniqueId,
    openLastVersion: [true, "true", "1", 1].includes(openLastVersion),
    addAccessAuthorization: [true, "true", "1", 1].includes(addAccessAuthorization),
    useBdgAccess: [true, "true", "1", 1].includes(useBdgAccess),
    bdgAccessReason,
  };
};

export const extractJSONOpenDocumentParams = (data) => {
  const { ins } = getInsFromPatient(data, remoteFormats.JSON);
  
  const { uniqueId, openLastVersion, addAccessAuthorization, useBdgAccess, bdgAccessReason } = data;
  
  return {
    ins,
    uniqueId,
    openLastVersion,
    addAccessAuthorization,
    useBdgAccess,
    bdgAccessReason
  };
};